const SYSTEM_ADMIN_EMAILS = new Set([
    "perst@multiconsult.no",
    "johnnie.gallon@multiconsult.no",
    "per.strom@multiconsult.no",
    "oskl@multiconsult.no",
    "oskar.lindgren@multiconsult.no",
]);
export const isSystemAdminEmail = (email) => SYSTEM_ADMIN_EMAILS.has((email ?? "").trim().toLowerCase());
